import { gql } from "@apollo/client";

export const INVOICES_GET_ALL = gql`
  query invoicesBySmartIndex($index: Int) {
    invoicesBySmartIndex(index: $index) {
      invoices {
        invoiceId
        status
        totalAmount
        monthYear
      }
      index
      hasNext
      hasPrevious
    }
  }
`;

export const GET_COST_AMOUNTS = gql`
  query GetCostAmounts($startMonth: Int!, $startYear: Int!, $endMonth: Int!, $endYear: Int!) {
    costAmounts(startMonth: $startMonth, startYear: $startYear, endMonth: $endMonth, endYear: $endYear) {
      amounts
      months
    }
  }
`;


